import { formatNumber } from "../../../../utils/format-sub";
import BandTag from "./BandTag";

const SOURCE_KEYS = ["referral", "coupon", "trial", "direct"];

const SourceBreakdownTable = ({ breakdown, currency = "usd", t }) => {
  if (!breakdown) return null;
  const money = (value) => formatNumber(value || 0, currency);
  const totalCount = breakdown.all.count || 0;
  const share = (count) =>
    totalCount > 0 ? Math.round((count / totalCount) * 100) : 0;

  return (
    <>
      <header className="table-card__header">
        <h3>{t("income.sourceChartTitle")}</h3>
        <BandTag kind="period" label={t("income.bands.period")} />
      </header>
      {/* biome-ignore lint/a11y/useValidAriaRole: report-table used for structure */}
      <table role="report-table" className="source-breakdown-table">
        <thead>
          <tr>
            <th>{t("income.sourceBreakdown.source")}</th>
            <th>{t("income.sourceBreakdown.newSubs")}</th>
            <th>{t("income.sourceBreakdown.mrrAdded")}</th>
            <th>{t("income.sourceBreakdown.share")}</th>
          </tr>
        </thead>
        <tbody>
          {SOURCE_KEYS.map((key) => (
            <tr key={key}>
              <td>
                <div className="source-breakdown-table__source">
                  <span className="pill" data-source={key}>
                    {t(`membershipList.sourceLabel.${key}`)}
                  </span>
                  {t(`income.sourceBreakdown.descriptions.${key}`)}
                </div>
              </td>
              <td>{breakdown[key].count}</td>
              <td>{money(breakdown[key].mrrAdded)}</td>
              <td>{share(breakdown[key].count)}%</td>
            </tr>
          ))}
          <tr className="source-breakdown-table__total">
            <td>{t("income.sourceBreakdown.allSources")}</td>
            <td>{breakdown.all.count}</td>
            <td>{money(breakdown.all.mrrAdded)}</td>
            <td>{share(breakdown.all.count)}%</td>
          </tr>
        </tbody>
      </table>
      <p className="p2 text-(--white-70) mt-3 px-6">
        {t("income.sourceBreakdown.precedenceNote")}
      </p>
    </>
  );
};

export default SourceBreakdownTable;
